module.exports = {
  /* Header error messages */
  "INVALID_LOC": "Invalid LOC header (bad signature)",
  "INVALID_CEN": "Invalid CEN header (bad signature)",
  "INVALID_END": "Invalid END header (bad signature)",
  /* ZipEntry error messages*/
  "NO_DATA": "Nothing to decompress",
  "BAD_CRC": "CRC32 checksum failed",
  "FILE_IN_THE_WAY": "There is a file in the way: %s",
  "UNKNOWN_METHOD": "Invalid/unsupported compression method",
  /* Inflater error messages */
  "AVAIL_DATA": "inflate::Available inflate data did not terminate",
  "INVALID_DISTANCE": "inflate::Invalid literal/length or distance code in fixed or dynamic block",
  "TO_MANY_CODES": "inflate::Dynamic block code description: too many length or distance codes",
  "INVALID_REPEAT_LEN": "inflate::Dynamic block code description: repeat more than specified lengths",
  "INVALID_REPEAT_FIRST": "inflate::Dynamic block code description: repeat lengths with no first length",
  "INCOMPLETE_CODES": "inflate::Dynamic block code description: code lengths codes incomplete",
  "INVALID_DYN_DISTANCE": "inflate::Dynamic block code description: invalid distance code lengths",
  "INVALID_CODES_LEN": "inflate::Dynamic block code description: invalid literal/length code lengths",
  "INVALID_STORE_BLOCK": "inflate::Stored block length did not match one's complement",
  "INVALID_BLOCK_TYPE": "inflate::Invalid block type (type == 3)",
  /* ADM-ZIP error messages */
  "CANT_EXTRACT_FILE": "Could not extract the file",
  "CANT_OVERRIDE": "Target file already exists",
  "NO_ZIP": "No zip file was loaded",
  "NO_ENTRY": "Entry doesn't exist",
  "DIRECTORY_CONTENT_ERROR": "A directory cannot have content",
  "FILE_NOT_FOUND": "File not found: %s",
  "NOT_IMPLEMENTED": "Not implemented",
  "INVALID_FILENAME": "Invalid filename",
  "INVALID_FORMAT": "Invalid or unsupported zip format. No END header found"
};